import type { SVGProps } from 'react';

const SvgUserOnLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M20 21C20 17.6829 16.4144 15 12 15C7.58556 15 4 17.6829 4 21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle cx={21.5781} cy={2} r={2} fill='#FF5A5A' />
  </svg>
);
export default SvgUserOnLt;
